import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./Pages/Home";
import "./App.css";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import ContactPage from "./components/JoinMovementForm/JoinMovementForm";
import useCanonicalUrl from './components/UseCanonicalUrl/useCanonicalUrl';
import Privacy from "./components/PrivacyPage/index"
import TermsAndConditions from "./components/TermsAndConditions/index"
import PostPage from "./components/MainPage/Blog/LatestBlogs/PostPage";
import Whitepaper from "./components/Whitepaper/Whitepaper";

function App() {
  const canonicalUrl = useCanonicalUrl();
  
  return (
    <React.Fragment>
      <Layout>
        <link rel="canonical" href={canonicalUrl} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<Navigate to="/error" />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<TermsAndConditions/>} />
          <Route path="/:postId/:postTitle" element={<PostPage />} />
          <Route path="/whitepaper/:section?" element={<Whitepaper />} />
          <Route path="/whitepaper" element={<Navigate to="/whitepaper/disclaimer" />} />
        </Routes>
      </Layout>
    </React.Fragment>
  );
}
export default App;
